import React, { useState } from 'react';
import { exportTimings } from './api';
import { EffectMarker } from './types';

interface ExportPanelProps {
  markers: number[];
  effectMarkers: EffectMarker[];
  duration: number;
  videoId: string;
  filename: string;
}

function computeSegments(markers: number[], duration: number): number[] {
  const sorted = [...markers].sort((a, b) => a - b);
  const segments: number[] = [];
  let prev = 0;
  for (const m of sorted) {
    segments.push(Math.round((m - prev) * 100) / 100);
    prev = m;
  }
  segments.push(Math.round((duration - prev) * 100) / 100);
  return segments;
}

export function ExportPanel({ markers, effectMarkers, duration, videoId, filename }: ExportPanelProps) {
  const [isExporting, setIsExporting] = useState(false);

  const segments = computeSegments(markers, duration);

  const handleExport = async () => {
    if (markers.length === 0) {
      alert('Нет маркеров для экспорта');
      return;
    }

    setIsExporting(true);
    try {
      const timingsText = await exportTimings(videoId, markers, duration, effectMarkers);

      // Download file
      const blob = new Blob([timingsText], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename.replace(/\.[^/.]+$/, '') + '_timings.txt';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      alert('Ошибка экспорта: ' + (error instanceof Error ? error.message : 'Unknown error'));
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="at-export-panel">
      <div className="at-markers-count">
        {markers.length} склеек / {segments.length} сегм. / {effectMarkers.length} эфф.
      </div>
      <button
        className="at-export-btn"
        onClick={handleExport}
        disabled={isExporting || markers.length === 0}
      >
        {isExporting ? 'Экспорт...' : 'Экспорт timings.txt'}
      </button>
    </div>
  );
}
